module.exports = __webpack_public_path__ + "img/montserrat.4e11012c.svg";